export default __webpack_public_path__ + "static/media/js.ba40d6a9.svg";